import { render, staticRenderFns } from "./features.html?vue&type=template&id=2da0a29f&scoped=true&"
import script from "./features.vue?vue&type=script&lang=ts&"
export * from "./features.vue?vue&type=script&lang=ts&"
import style0 from "./features.scss?vue&type=style&index=0&id=2da0a29f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0a29f",
  null
  
)

export default component.exports